// src/app/shared/utils/word-limit.util.ts


/** Counts words the same way the questionnaire's word counters already do. */
export function countWords(text: string | null | undefined): number {
  if (!text) { return 0; }
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export function truncateToWordLimit(value: string | null | undefined, limit?: number | null): string {
  if (!value || !limit) { return value || ''; }
  const wordRe = /\S+/g;
  let matchCount = 0;
  let cutoff = -1;
  let overflow = false;
  let match: RegExpExecArray | null;
  while ((match = wordRe.exec(value)) !== null) {
    matchCount++;
    if (matchCount === limit) {
      cutoff = match.index + match[0].length;
    } else if (matchCount > limit) {
      overflow = true;
      break;
    }
  }
  if (!overflow || cutoff === -1) { return value; }
  return value.slice(0, cutoff);
}